import * as types from "../actionTypes/modalTypes";

export const setModal = (modalType, modalProps) => ({
  type: types.SET_MODAL,
  data: { modalType, modalProps },
});
export const unsetModal = () => ({ type: types.UNSET_MODAL });
